import { css } from '@emotion/css';

import { gray7 } from 'lib/styles/color';

export const errorContainerStyle = css`
  padding-top: 80px;
  text-align: center;
`;

export const errorIconStyle = css`
  font-size: 180px;
`;

export const errorTextStyle = css`
  margin-top: 8px;
  font-size: 14px;
  color: ${gray7};
  text-align: center;
`;

export const errorBtnStyle = css`
  margin-top: 8px;
  font-size: 14px;
`;
